export enum ChartStatus{
    VIEWS = "VIEWS",
    ENGAGEMENT = "ENGAGEMENT",
    CLICKS = "CLICKS"
}

export const ChartStatusToShow: Record<ChartStatus, string> = {
  [ChartStatus.VIEWS]: "filter.splineFilter.impressions",
  [ChartStatus.ENGAGEMENT]: "Charts.completed",
  [ChartStatus.CLICKS]: "Charts.clicks"
};

export interface ChartStatusInterface {
  id: ChartStatus;
  value: string;
}